import React, { useState } from 'react';
import { FormControlLabel, Switch } from '@mui/material';
import ConfirmationModal from '../atoms/ConfirmationModal';
import { makePrimayParent } from '../../redux/action';
import { useDispatch } from 'react-redux';

const MarkPrimaryParentSwitch = ({ item, caseloadId }: any) => {
  const dispatch = useDispatch()
  const [isPrimaryParent, setIsPrimaryParent] = useState(false);
  const [isTargetId, setIsTargetId] = useState<any>(null);

  const handleMakePrimaryParent = async () => {
    try {
      await dispatch(makePrimayParent(caseloadId, isTargetId));
    } finally {
      setIsPrimaryParent(false);
    }
  };

  const handleMakePrimaryToggle = (event: any, item: any) => {
    setIsPrimaryParent(event.target.checked);
    setIsTargetId(item?.user?.id);
  };

  return (
    <>
      <FormControlLabel
        sx={{
          ml: {
            xl:3,
            md:0,
            sm:0,
            xs:0
          },
          '.MuiFormControlLabel-label': {
            fontSize: 14,
            color: '#6A2382'
          }
        }}
        control={
          <Switch
            checked={isPrimaryParent}
            onChange={(event) => handleMakePrimaryToggle(event, item)}
          />
        }
        label="( Mark as a Primary Parent )"
      />

      {isPrimaryParent && (
        <ConfirmationModal
          open={isPrimaryParent}
          handleClose={() => setIsPrimaryParent(false)}
          title="Confirmation"
          message="Are you sure you want to make the additional parent the primary parent? Doing so will delete the Reports filled by them."
          onConfirm={handleMakePrimaryParent}
          onCancel={() => setIsPrimaryParent(false)}
        />
      )}
    </>
  );
};

export default MarkPrimaryParentSwitch;
